import { render, staticRenderFns } from "./Frame.vue?vue&type=template&id=34e81ef1&scoped=true&"
import script from "./Frame.vue?vue&type=script&lang=js&"
export * from "./Frame.vue?vue&type=script&lang=js&"
import style0 from "./Frame.vue?vue&type=style&index=0&id=34e81ef1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e81ef1",
  null
  
)

export default component.exports